/**
 * API Documentation for EHS tools
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import ErgoRiskMatrix from '../model/ErgoRiskMatrix';
import PageErgoRiskMatrix from '../model/PageErgoRiskMatrix';

/**
* Ergoriskmatrixcontroller service.
* @module api/ErgoriskmatrixcontrollerApi
* @version 1.0
*/
export default class ErgoriskmatrixcontrollerApi {

    /**
    * Constructs a new ErgoriskmatrixcontrollerApi. 
    * @alias module:api/ErgoriskmatrixcontrollerApi
    * @class
    * @param {module:ApiClient} apiClient Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }



    /**
     * create
     * @param {module:model/ErgoRiskMatrix} ergoRiskMatrix ergoRiskMatrix
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ErgoRiskMatrix} and HTTP response
     */
    createErgoRiskMatrixWithHttpInfo(ergoRiskMatrix) {
      let postBody = ergoRiskMatrix;

      // verify the required parameter 'ergoRiskMatrix' is set
      if (ergoRiskMatrix === undefined || ergoRiskMatrix === null) {
        throw new Error("Missing the required parameter 'ergoRiskMatrix' when calling createErgoRiskMatrix");
      }


      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['spring_oauth'];
      let contentTypes = ['application/json'];
      let accepts = ['*/*'];
      let returnType = ErgoRiskMatrix;

      return this.apiClient.callApi(
        '/api/riskmatrix/', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * create
     * @param {module:model/ErgoRiskMatrix} ergoRiskMatrix ergoRiskMatrix
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ErgoRiskMatrix}
     */
    createErgoRiskMatrix(ergoRiskMatrix) {
      return this.createErgoRiskMatrixWithHttpInfo(ergoRiskMatrix)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * delete
     * @param {Number} id id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ErgoRiskMatrix} and HTTP response
     */
    deleteErgoRiskMatrixWithHttpInfo(id) {
      let postBody = null;

      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling deleteErgoRiskMatrix");
      }


      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['spring_oauth'];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = ErgoRiskMatrix;

      return this.apiClient.callApi(
        '/api/riskmatrix/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * delete
     * @param {Number} id id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ErgoRiskMatrix}
     */
    deleteErgoRiskMatrix(id) {
      return this.deleteErgoRiskMatrixWithHttpInfo(id)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * get
     * @param {Number} id id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ErgoRiskMatrix} and HTTP response
     */
    getErgoRiskMatrixWithHttpInfo(id) {
      let postBody = null;

      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getErgoRiskMatrix");
      }


      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['spring_oauth'];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = ErgoRiskMatrix;

      return this.apiClient.callApi(
        '/api/riskmatrix/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * get
     * @param {Number} id id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ErgoRiskMatrix}
     */
    getErgoRiskMatrix(id) {
      return this.getErgoRiskMatrixWithHttpInfo(id)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * index
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page page (default to 0)
     * @param {Number} opts.pageSize pageSize (default to 20)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/PageErgoRiskMatrix} and HTTP response
     */
    getErgoRiskMatrixesWithHttpInfo(opts) {
      opts = opts || {};
      let postBody = null;


      let pathParams = {
      };
      let queryParams = {
        'page': opts['page'],
        'pageSize': opts['pageSize']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['spring_oauth'];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = PageErgoRiskMatrix;

      return this.apiClient.callApi(
        '/api/riskmatrix/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * index
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page page (default to 0)
     * @param {Number} opts.pageSize pageSize (default to 20)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/PageErgoRiskMatrix}
     */
    getErgoRiskMatrixes(opts) {
      return this.getErgoRiskMatrixesWithHttpInfo(opts)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * getByUser
     * @param {String} email email
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page page (default to 0)
     * @param {Number} opts.pageSize pageSize (default to 20)
     * @param {Number} opts.sequence sequence (default to 0)
     * @param {String} opts.sortType sortType
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/PageErgoRiskMatrix} and HTTP response
     */
    getErgoRiskMatrixesByUserWithHttpInfo(email, opts) {
      opts = opts || {};
      let postBody = null;

      // verify the required parameter 'email' is set
      if (email === undefined || email === null) {
        throw new Error("Missing the required parameter 'email' when calling getErgoRiskMatrixesByUser");
      }


      let pathParams = {
        'email': email
      };
      let queryParams = {
        'page': opts['page'],
        'pageSize': opts['pageSize'],
        'sequence': opts['sequence'],
        'sortType': opts['sortType']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['spring_oauth'];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = PageErgoRiskMatrix;

      return this.apiClient.callApi(
        '/api/riskmatrix/users/{email}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * getByUser
     * @param {String} email email
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page page (default to 0)
     * @param {Number} opts.pageSize pageSize (default to 20)
     * @param {Number} opts.sequence sequence (default to 0)
     * @param {String} opts.sortType sortType
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/PageErgoRiskMatrix}
     */
    getErgoRiskMatrixesByUser(email, opts) {
      return this.getErgoRiskMatrixesByUserWithHttpInfo(email, opts)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * getMine
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page page (default to 0)
     * @param {Number} opts.pageSize pageSize (default to 20)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/PageErgoRiskMatrix} and HTTP response
     */
    getMyErgoRiskMatrixesWithHttpInfo(opts) {
      opts = opts || {};
      let postBody = null;


      let pathParams = {
      };
      let queryParams = {
        'page': opts['page'],
        'pageSize': opts['pageSize']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['spring_oauth'];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = PageErgoRiskMatrix;

      return this.apiClient.callApi(
        '/api/riskmatrix/users/current_user', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * getMine
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page page (default to 0)
     * @param {Number} opts.pageSize pageSize (default to 20)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/PageErgoRiskMatrix}
     */
    getMyErgoRiskMatrixes(opts) {
      return this.getMyErgoRiskMatrixesWithHttpInfo(opts)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * update
     * @param {module:model/ErgoRiskMatrix} ergoRiskMatrix ergoRiskMatrix
     * @param {Number} id id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ErgoRiskMatrix} and HTTP response
     */
    updateErgoRiskMatrixWithHttpInfo(ergoRiskMatrix, id) {
      let postBody = ergoRiskMatrix;

      // verify the required parameter 'ergoRiskMatrix' is set
      if (ergoRiskMatrix === undefined || ergoRiskMatrix === null) {
        throw new Error("Missing the required parameter 'ergoRiskMatrix' when calling updateErgoRiskMatrix");
      }

      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateErgoRiskMatrix");
      }


      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['spring_oauth'];
      let contentTypes = ['application/json'];
      let accepts = ['*/*'];
      let returnType = ErgoRiskMatrix;

      return this.apiClient.callApi(
        '/api/riskmatrix/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * update
     * @param {module:model/ErgoRiskMatrix} ergoRiskMatrix ergoRiskMatrix
     * @param {Number} id id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ErgoRiskMatrix}
     */
    updateErgoRiskMatrix(ergoRiskMatrix, id) {
      return this.updateErgoRiskMatrixWithHttpInfo(ergoRiskMatrix, id)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


}
